import React from 'react';
import PlanBills from '../../components/Account/PlanBills';

const OnboardingPage: React.FC = () => {
  return <PlanBills isOnboarding={true} />;
};

export default OnboardingPage;
